
















































import { Component, Vue } from 'vue-property-decorator';
import storage from '../utils/storage';
import Loading from '../components/Loading.vue';
import moment from 'moment';
import echartsColumn from '../components/echarts/EchartsColumn.vue';
import tableModel from '../components/table/tableModel.vue';
@Component({
  components: {
    Loading,
    echartsColumn,
    tableModel,
  },
})
export default class LetterTrack extends Vue {
  private user: any;
  private beforeTime: any = moment(new Date()).subtract(27, 'days').format('YYYY-MM-DD');
  private afterTime: any = moment(new Date()).format('YYYY-MM-DD');
  private customerBeforeTime: any = moment(new Date()).subtract(27, 'days').format('YYYY-MM-DD');
  private customerAfterTime: any = moment(new Date()).format('YYYY-MM-DD');
  private dateFormat = 'YYYY-MM-DD';
  private moment: any = moment;
  private createDataTime: any = [this.beforeTime, this.afterTime];
  private customerDataTime: any = [this.beforeTime, this.afterTime];
  private spinning = false;
  private giftType: string = '';
  private dataJson: any = [];
  private giftJson: any = [];
  private giftDetailJson: any = [];
  private SKUkey: string = '';
  private allNum: number = 1;
  private isEcharts: boolean = false;
  private columns: any = [ {
    title: '5 Star',
    dataIndex: 'count_rate5',
    width: '30%',
    scopedSlots: { customRender: 'count_rate5' },
  }, {
    title: 'Customer',
    dataIndex: 'count_customer',
    width: '20%',
    scopedSlots: { customRender: 'count_customer' },
  }, {
    title: 'CustomerPercentage',
    dataIndex: 'CustomerPercentage',
    width: '20%',
    scopedSlots: { customRender: 'CustomerPercentage' },
  }, {
    title: 'ALL',
    dataIndex: 'count_all',
    width: '20%',
    scopedSlots: { customRender: 'count_all' },
  }];

  private columnsGift: any = [{
    title: 'Star',
    dataIndex: 'Star',
    width: '10%',
    scopedSlots: { customRender: 'Star' },
  }, {
    title: 'GiftType',
    dataIndex: 'GiftType',
    width: '20%',
    scopedSlots: { customRender: 'GiftType' },
  }, {
    title: 'CountNum',
    dataIndex: 'CountNum',
    width: '20%',
    scopedSlots: { customRender: 'CountNum' },
  }];
  private columnsGiftDetail: any = [{
    title: 'appraiseTime',
    dataIndex: 'appraiseTime',
    width: '32%',
    scopedSlots: { customRender: 'appraiseTime' },
  }, {
    title: 'orderID',
    dataIndex: 'orderID',
    width: '32%',
    scopedSlots: { customRender: 'orderID' },
  }, {
    title: 'star',
    dataIndex: 'star',
    width: '10%',
    scopedSlots: { customRender: 'star' },
  }, {
    title: 'selectGift',
    dataIndex: 'selectGift',
    width: '20%',
    scopedSlots: { customRender: 'selectGift' },
  }];
  private mounted() {
    this.user = storage.get('user');
    if (this.user) {
      console.log('please login');
    } else {
     this.$router.push({
        path: '/login',
      });
    }
  }
  private async getLetterDetailData() {
    this.giftDetailJson.splice(0, this.giftDetailJson.length);
    this.spinning = true;
    // 清空数组
    const url: string = '/api/getLetterDetail';
    const str = ' 23:59:59';
    const formatStr = 'YYYY-MM-DD HH:mm:ss';
    const creatDataTime = [moment(this.createDataTime[0]).format(formatStr), this.createDataTime[1] + str];
    const customerDataTime = [moment(this.customerDataTime[0]).format(formatStr), this.customerDataTime[1] + str];
    const args = {
      createTime: creatDataTime,
      customerTime: customerDataTime,
      Keyword: this.SKUkey,
      giftType: this.giftType,
      team: this.user.userName,
    };
    try {
      const data = await this.axios.post(url, args);
      if (data.data && data.data.data) {
        console.log(data.data.data);
        let dataJson = data.data.data;
        dataJson = this.fifterDataJson(dataJson);
        this.giftDetailJson = dataJson;
        this.spinning = false;
        this.isEcharts = true;
      }
    } catch ( err ) {
      console.log(err);
      this.spinning = false;

    }
  }
  private utc2beijing(utcDatetime: string) {
    // 转为正常的时间格式 年-月-日 时:分:秒
    const TPos = utcDatetime.indexOf('T');
    const ZPos = utcDatetime.indexOf('Z');
    const yearMonthDay = utcDatetime.substr(0, TPos);
    const hourMinuteSecond = utcDatetime.substr(TPos + 1, ZPos - TPos - 1);
    const newDatetime = yearMonthDay + ' ' + hourMinuteSecond; // 2017-03-31 08:02:06
    // 处理成为时间戳
    let timestamp: any = new Date(Date.parse(newDatetime));
    timestamp = timestamp.getTime();
    timestamp = timestamp / 1000;
    // 增加8个小时，北京时间比utc时间多八个时区
    timestamp = timestamp + 8 * 60 * 60;
    // 时间戳转为时间
    const beijingDatetime = new Date(parseInt(timestamp, 10) * 1000).toLocaleString();
    return beijingDatetime;  // 2017-03-31 16:02:06
  }
  private fifterDataJson( dataJson: any ) {
    dataJson.forEach((item: any, index: number) => {
      if (item.star === '5' && item.selectGift === '9') {
        dataJson[index].selectGift = 'same product';
      } else if (item.star !== '5' && item.selectGift === '9') {
        dataJson[index].selectGift = 'I don\'t know';
      }
      dataJson[index].appraiseTime = this.utc2beijing(item.appraiseTime);
    });
    return dataJson;
  }
  private async getData() {
    const that = this;
    this.giftJson.splice(0, this.giftJson.length);
    this.isEcharts = false;
    this.spinning = true;
    // 清空数组
    that.allNum = 1;
    const url: string = '/api/getLetterTrack';
    const str = ' 23:59:59';
    const formatStr = 'YYYY-MM-DD HH:mm:ss';
    const creatDataTime = [moment(this.createDataTime[0]).format(formatStr), this.createDataTime[1] + str];
    const customerDataTime = [moment(this.customerDataTime[0]).format(formatStr), this.customerDataTime[1] + str];
    const args = {
      createTime: creatDataTime,
      customerTime: customerDataTime,
      Keyword: this.SKUkey,
      giftType: this.giftType,
      team: this.user.userName,
    };
    try {
      const data = await this.axios.post(url, args);
      if (data.data && data.data.giftData.length > 0 && data.data.data) {
        that.dataJson = data.data.data;
        const changeGiftData = data.data.giftData[0];
        const typeSelect = data.data.typeSelect;
        const typeKeysArr = this.filterTypeKey(typeSelect);
        const keys = Object.keys(changeGiftData);
        let SKUkeyArr: any  = [];
        if (this.SKUkey.indexOf(',') > -1) {
          SKUkeyArr = this.SKUkey.split(',');
        } else {
          SKUkeyArr = [this.SKUkey];
        }
        typeKeysArr.forEach((key: string ) => {
          const obj: any = {};
          const GiftType = 'GiftType';
          const Star = 'Star';
          const CountNum = 'CountNum';
          if (key === '9') {
            obj[GiftType] = 'Same Product';
          } else {
            obj[GiftType] = 'Gift $' + key;
          }
          let num: number = 0;
          SKUkeyArr.forEach(( sku: string ) => {
            try {
              num = num + Number(changeGiftData[key + sku]);
            } catch (err) {
              console.log(sku + ' sku 无数据');
            }
          });
          obj[CountNum] = num;
          obj[Star] = '5✨';
          that.giftJson.push(obj);
        });
      }
      that.dataJson.forEach((item: any, index: number) => {
        const indexStr: string = 'CustomerPercentage';
        that.dataJson[index][indexStr] = (Number((item.count_customer / item.count_all)) * 100).toFixed(4) + '%';
      });
      this.getLetterDetailData();
    } catch (err) {
      this.spinning = false;
      console.log(err);
    }

  }
  private filterTypeKey(typeSelect: any) {
    let typeKeys: any = [];
    typeSelect.forEach((list: any, index: number) => {
      typeKeys.push(list.selectGift);
    });
    typeKeys = this.unique(typeKeys);
    return typeKeys;
  }
  private unique(arr: any) {
    return Array.from(new Set(arr));
  }
  private onPickerCreateChange(date: any, dateString: string) {
    this.createDataTime = dateString;
  }
  private onPickerCustomerChange(date: any, dateString: string) {
    this.customerDataTime = dateString;
  }

  private getCurrentStyle(current: any, today: any): any {
    const style: any = {};
    if (current.date() === 1) {
      style.border = '1px solid #1890ff';
      style.borderRadius = '50%';
    }
    return style;
  }
  private emitEmpty() {
    const inputBox: HTMLInputElement = this.$refs.SKUkeyInput as HTMLInputElement;
    inputBox.focus();
    this.SKUkey = '';
  }
}
